var React = require('react');

function CalendarTime (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6ZM5 6.41421V2H7V5.58579L9.20711 7.79289L7.79289 9.20711L5 6.41421Z","fill":"currentColor"}));
}

CalendarTime.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarTime;

CalendarTime.default = CalendarTime;
